import { useState } from "react";
import { imageUrl } from "../lib/cloudinary";

/**
 * 1×1 white PNG placeholder — keeps the cart row layout stable when no
 * usable image is available (e.g. legacy cart entries written before the
 * iter34 image-resolution fix).
 */
export const BLANK_PLACEHOLDER =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkAAIAAAoAAv/lxKUAAAAASUVORK5CYII=";

/**
 * CartItemImage — renders an <img> with automatic fallback to the
 * BLANK_PLACEHOLDER on load error or when the src is empty.  Designed for
 * the Cart and Checkout line-item rendering; preserves the parent's
 * sizing/object-fit classes via the `className` prop.
 */
export default function CartItemImage({ src, alt, className = "", testid }) {
  const [errored, setErrored] = useState(false);
  // Cart thumbnails render at ~96–128 px so we only need a tiny Cloudinary build.
  const effective = !src || errored ? BLANK_PLACEHOLDER : imageUrl(src, { width: 120, height: 120, crop: "fill" });
  return (
    <img
      src={effective}
      alt={alt || ""}
      onError={() => setErrored(true)}
      className={className}
      loading="lazy"
      data-testid={testid}
    />
  );
}
